export const LIST_SERVICE_GROUP_REQUEST = 'LIST_SERVICE_GROUP_REQUEST'
export const LIST_SERVICE_GROUP_SUCCESS = 'LIST_SERVICE_GROUP_SUCCESS'
export const LIST_SERVICE_GROUP_FAIL = 'LIST_SERVICE_GROUP_FAIL'

export const CREATE_SERVICE_GROUP_REQUEST = 'CREATE_SERVICE_GROUP_REQUEST'
export const CREATE_SERVICE_GROUP_SUCCESS = 'CREATE_SERVICE_GROUP_SUCCESS'
export const CREATE_SERVICE_GROUP_FAIL = 'CREATE_SERVICE_GROUP_FAIL'

export const CREATE_SERVICE_GROUP_SERVICE_REQUEST = 'CREATE_SERVICE_GROUP_SERVICE_REQUEST'
export const CREATE_SERVICE_GROUP_SERVICE_SUCCESS = 'CREATE_SERVICE_GROUP_SERVICE_SUCCESS'
export const CREATE_SERVICE_GROUP_SERVICE_FAIL = 'CREATE_SERVICE_GROUP_SERVICE_FAIL'

export const DETAIL_SERVICE_GROUP_SERVICE_REQUEST = 'DETAIL_SERVICE_GROUP_SERVICE_REQUEST'
export const DETAIL_SERVICE_GROUP_SERVICE_SUCCESS = 'DETAIL_SERVICE_GROUP_SERVICE_SUCCESS'
export const DETAIL_SERVICE_GROUP_SERVICE_FAIL = 'DETAIL_SERVICE_GROUP_SERVICE_FAIL'

export const DETAIL_SERVICE_GROUP_REQUEST = 'DETAIL_SERVICE_GROUP_REQUEST'
export const DETAIL_SERVICE_GROUP_SUCCESS = 'DETAIL_SERVICE_GROUP_SUCCESS'
export const DETAIL_SERVICE_GROUP_FAIL = 'DETAIL_SERVICE_GROUP_FAIL'

export const UPDATE_SERVICE_GROUP_REQUEST = 'UPDATE_SERVICE_GROUP_REQUEST'
export const UPDATE_SERVICE_GROUP_SUCCESS = 'UPDATE_SERVICE_GROUP_SUCCESS'
export const UPDATE_SERVICE_GROUP_FAIL = 'UPDATE_SERVICE_GROUP_FAIL'

export const UPDATE_SERVICE_GROUP_SERVICE_REQUEST = 'UPDATE_SERVICE_GROUP_SERVICE_REQUEST'
export const UPDATE_SERVICE_GROUP_SERVICE_SUCCESS = 'UPDATE_SERVICE_GROUP_SERVICE_SUCCESS'
export const UPDATE_SERVICE_GROUP_SERVICE_FAIL = 'UPDATE_SERVICE_GROUP_SERVICE_FAIL'

export const DELETE_SERVICE_GROUP_REQUEST = 'DELETE_SERVICE_GROUP_REQUEST'
export const DELETE_SERVICE_GROUP_SUCCESS = 'DELETE_SERVICE_GROUP_SUCCESS'
export const DELETE_SERVICE_GROUP_FAIL = 'DELETE_SERVICE_GROUP_FAIL'

export const DELETE_SERVICE_GROUP_SERVICE_REQUEST = 'DELETE_SERVICE_GROUP_SERVICE_REQUEST'
export const DELETE_SERVICE_GROUP_SERVICE_SUCCESS = 'DELETE_SERVICE_GROUP_SERVICE_SUCCESS'
export const DELETE_SERVICE_GROUP_SERVICE_FAIL = 'DELETE_SERVICE_GROUP_SERVICE_FAIL'

export const RESET_SERVICE_GROUP = 'RESET_SERVICE_GROUP'
